import axios from 'axios';
import { POST_CABLE_OPTIC_HIGHWAY_API_URL, POST_WELL_CANTON_API_URL, POST_FOB_HIGHWAY_API_URL,
    POST_PILLAR_HIGHWAY_API_URL, POST_COUPLING_HIGHWAY_API_URL, POST_CABLE_OPTIC_CANTON_API_URL, POST_PON_BOX_CANTON_API_URL, POST_PON_BOX_CANTON_NODE_API_URL,
    POST_FOB_CANTON_NODE_API_URL,
    POST_KTV_AMPLIFIER_NODE_API_URL,
    POST_OP_NODE_API_URL,
    POST_PILLAR_MANUALLY_HIGHWAY_API_URL,
    POST_PILLAR_MANUALLY_CANTON_API_URL,
    POST_DIVIDER_NODE_API_URL,
    POST_CASSETTE_NODE_API_URL,
    POST_PASSIVE_NODE_HIGHWAY_API_URL,
    POST_KTV_AMPLIFIER_PASSIVE_NODE_API_URL,
    POST_OP_PASSIVE_NODE_API_URL,
    POST_PON_BOX_CANTON_PASSIVE_NODE_API_URL,
    POST_FOB_CANTON_PASSIVE_NODE_API_URL,
    POST_DIVIDER_PASSIVE_NODE_API_URL,
    POST_CASSETTE_PASSIVE_NODE_API_URL,
    POST_RESERVE_NODE_API_URL} from '../OpticApiConfig';
import { CONST_CANTON, CONST_HIGHWAY } from '../Constants/ConstantsOptics';

// запись таблицу FobHighway
 export const WriteFobHighway = async (event, coordinatesFob, selectedFob, commentTextAreaRefFob, selectedCity, fobMarker, showSnackbar, 
    setCoordinatesFob, setCommentFob,handleClickSummit,setSelectedFob, selectedRankFob, setSelectedRankFob, user, highwayTerritory) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefFob.current.value;

    if (coordinatesFob.length === 0 || comment.trim() === '' || selectedRankFob == null) {
        showSnackbar('Фоб! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(fobMarker === true){
        showSnackbar('Фоб! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
        await Promise.all(coordinatesFob.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_FOB_HIGHWAY_API_URL}?flag=${flag}`, {
                FobId: selectedFob,
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                City: city,
                Canton: canton,
                Area: area,
                Status: 1,
                RankComponentId: selectedRankFob,
                AuthorId: user                 
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }));          
        
        setCoordinatesFob([]);
        setCommentFob("");
        setSelectedRankFob(null);
        setSelectedFob([]);
        handleClickSummit();
        showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу PassiveNode
 export const WritePassiveNodeHighway = async (event, coordinatesPassiveNode, selectedCity, passiveNodeMarker, showSnackbar, 
    setCoordinatesPassiveNode,handleClickSummit, user, highwayTerritory) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();

    if (coordinatesPassiveNode.length === 0 ) {
        showSnackbar('Узел! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(passiveNodeMarker === true){
        showSnackbar('Узел! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
        await Promise.all(coordinatesPassiveNode.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_PASSIVE_NODE_HIGHWAY_API_URL}?flag=${flag}`, {
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                City: city,
                Canton: canton,
                Area: area,
                AuthorId: user                 
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }));          
        
        setCoordinatesPassiveNode([]);
        handleClickSummit();
        showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу FobNode
export const WriteFobNode = async (event, latitude, longitude, selectedFob, commentTextAreaRefFob, canton, area, 
    setCommentFob,cantonRefresh,setSelectedFob, user,  hid, entrance,  showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefFob.current.value;

    if (selectedFob === null || selectedFob === "null" || selectedFob === undefined || comment.trim() === '') {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
       showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_FOB_CANTON_NODE_API_URL}`,
                {
                  FobId: selectedFob,
                  Latitude: latitude,
                  Longitude: longitude,
                  Description: comment,
                  Canton: canton,
                  Area: area,
                  Status: 1,
                  RankComponentId: 4,
                  AuthorId: user
                },
                {
                  params: {
                    hid: hid,
                    entrance: entrance,
                  },
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                }
              );
                        
        setCommentFob("");
        setSelectedFob([]);
        cantonRefresh();
       
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу FobNodePassive
export const WriteFobNodePassive = async (event, latitude, longitude, selectedFob, commentTextAreaRefFob, canton, area, 
    setCommentFob,cantonRefresh,setSelectedFob, user, nodeId, hid, entrance,  showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefFob.current.value;

    if (selectedFob === null || selectedFob === "null" || selectedFob === undefined || comment.trim() === '') {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
       showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_FOB_CANTON_PASSIVE_NODE_API_URL}`,
                {
                  FobId: selectedFob,
                  Latitude: latitude,
                  Longitude: longitude,
                  Description: comment,
                  Canton: canton,
                  Area: area,
                  Status: 1,
                  RankComponentId: 4,
                  AuthorId: user
                },
                {
                  params: {
                    nodeId: nodeId,
                    hid: hid,
                    entrance: entrance,
                  },
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                }
              );
                        
        setCommentFob("");
        setSelectedFob([]);
        showSnackbar('FOB добавлен!', 'snackbarWarning');
        cantonRefresh();
       
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу PonBoxLocation
export const WritePonBoxHighway = async (event, coordinatesPonBox, selectedPonBox, commentTextAreaRefPonBox, selectedCity, ponBoxMarker, showSnackbar, 
    setCoordinatesPonBox, setCommentPonBox,handleClickSummit,setSelectedPonBox,  user, highwayTerritory) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefPonBox.current.value;

    if (coordinatesPonBox.length === 0 || comment.trim() === '') {
        showSnackbar('Пон-бокс! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(ponBoxMarker === true){
        showSnackbar('Пон-бокс! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
        await Promise.all(coordinatesPonBox.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_PON_BOX_CANTON_API_URL}?flag=${flag}`, {
                PonBoxId: selectedPonBox,
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                City: city,
                Canton: canton,
                Area: area,
                Status: 1,
                RankComponentId: 4,
                AuthorId: user                 
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }));          
        
        setCoordinatesPonBox([]);
        setCommentPonBox("");
        setSelectedPonBox([]);
        handleClickSummit();
        showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу PonBoxLocationNode
export const WritePonBoxNode = async (event, latitude, longitude, selectedPonBox, commentTextAreaRefPonBox, canton, area, 
    setCommentPonBox,cantonRefresh, setSelectedPonBox, user,  hid, entrance, showSnackbar) => {

   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefPonBox.current.value;

    if (selectedPonBox === null || selectedPonBox === "null" || selectedPonBox === undefined || comment.trim() === '') {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_PON_BOX_CANTON_NODE_API_URL}`,
                {
                  PonBoxId: selectedPonBox,
                  Latitude: latitude,
                  Longitude: longitude,
                  Description: comment,
                  Canton: canton,
                  Area: area,
                  Status: 1,
                  RankComponentId: 4,
                  AuthorId: user
                },
                {
                  params: {
                    hid: hid,
                    entrance: entrance,
                  },
                  headers: {
                    'Authorization': `Bearer ${token}`,
                  },
                }
              );
                        
        setCommentPonBox("");
        setSelectedPonBox([]);
        
        
        cantonRefresh();
         
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу PonBoxLocationNodePassive
export const WritePonBoxPassiveNode = async (event, latitude, longitude, selectedPonBox, commentTextAreaRefPonBox, canton, area, 
    setCommentPonBox,cantonRefresh, setSelectedPonBox, user, nodeId, hid, entrance, showSnackbar) => {

   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefPonBox.current.value;

    if (selectedPonBox === null || selectedPonBox === "null" || selectedPonBox === undefined || comment.trim() === '') {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_PON_BOX_CANTON_PASSIVE_NODE_API_URL}`,
                {
                  PonBoxId: selectedPonBox,
                  Latitude: latitude,
                  Longitude: longitude,
                  Description: comment,
                  Canton: canton,
                  Area: area,
                  Status: 1,
                  RankComponentId: 4,
                  AuthorId: user
                },
                {
                  params: {
                    nodeId: nodeId,  
                    hid: hid,
                    entrance: entrance,
                  },
                  headers: {
                    'Authorization': `Bearer ${token}`,
                  },
                }
              );
                        
        setCommentPonBox("");
        setSelectedPonBox([]);
        showSnackbar('Пон-бокс добавлен!', 'snackbarWarning');
        
        cantonRefresh();
         
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу WellHighway
export const WriteWellHighway = async (event, coordinatesManhole, commentTextAreaRefManhole, selectedCity, manholeMarker, showSnackbar,
     setCoordinatesManhole, setCommentManhole, handleClickSummit, selectedOwnerWell,setSelectedOwnerWell, user, highwayTerritory) => {  

    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefManhole.current.value;
    if (coordinatesManhole.length === 0 || comment.trim() === '' || selectedOwnerWell == null ) {
        showSnackbar('Колодец! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(manholeMarker == true){
        showSnackbar('Колодец! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else{
        try {
          await Promise.all(coordinatesManhole.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_WELL_CANTON_API_URL}?flag=${flag}`, {
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                City: city,
                Canton: canton,
                Area: area,
                Status: 1,
                Rank: 0,
                OwnerWellId: selectedOwnerWell,
                AuthorId: user                 
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
          }));
           
          setCoordinatesManhole([]);
          setCommentManhole("");  
          setSelectedOwnerWell(null);
          handleClickSummit();       
          showSnackbar('Колодец! Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись LineOpticHighway
export const WriteLineOpticHighway = async (coordinatesCableLine, commentTextAreaRefCable,selectedContractor, cableOpticId, cableTypeId, isLineDrawing, showSnackbar, 
    setCoordinatesCableLine, setCommentCable, setSelectedCable,setSelectedTypeCable,setSelectedContractor, handleClickSummit,setLengthCable,lengthCable,
    setSelectedRankCable,selectedRankCable, user, cantonCablaByIdRefresh) => {  

    const token = localStorage.getItem('token');

    // console.log("WriteLineOpticHighway");
    // console.log(coordinatesCableLine);


    const comment = commentTextAreaRefCable.current.value;
        if (coordinatesCableLine.length === 0 || comment.trim() === '' || selectedContractor === null || selectedRankCable == null) {
            showSnackbar('Кабель! Не все поля заполнены!', 'snackbarWarning');
        return;
        } else if(isLineDrawing == true){
            showSnackbar('Кабель! Завершите действие!', 'snackbarWarning');
        } else if(!token){
            showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
        } else{
        try {
            // const coordinatesArray = coordinatesCableLine.map(coord => {
            //     return {
            //         Latitude: coord.lat,
            //         Longitude: coord.lng
            //     };
            // });
            const coordinatesArray = coordinatesCableLine.map(coord => {
                if (coord.latLng) {
                    return {
                        Latitude: coord.latLng.lat,
                        Longitude: coord.latLng.lng,
                        City: coord.highwayCity,
                        // Canton: 'dsfds',
                        // Area: '123',
                        // Flag: "flag",
                        LengthSegment: coord.lengthSegment
                    };
                }
                return null;
            }).filter(coord => coord !== null); // Фильтруем null значения

            // console.log("coordinatesArrayefsf");
            // console.log(coordinatesArray);

            const response = await axios.post(POST_CABLE_OPTIC_HIGHWAY_API_URL, {
                Coordinates: coordinatesArray,
                CableId: cableOpticId,
                CableTypeId: cableTypeId,
                Description: comment,
                ContractorId: selectedContractor,
                //City: selectCityCable,
                AuthorId: user,
                RankCableId: selectedRankCable,
                Status: 1,
                Order: 0,
                LengthCable: lengthCable                   
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const newLineId = response.data;
                
            setCoordinatesCableLine([]);
            setCommentCable("");   
            setSelectedCable([]);
            setSelectedTypeCable(null);
            setSelectedContractor(null);
            setSelectedRankCable(null);
            setLengthCable(0);
            cantonCablaByIdRefresh(newLineId);
            //handleClickSummit();
            showSnackbar('Кабель! Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

//запись PillarHighway
export const WritePillarHighway = async (event, coordinatesPillar, commentTextAreaRefPillar, selectedCity, pillarMarker, showSnackbar, setCoordinatesPillar, 
        setCommentPillar, handleClickSummit, selectedOwnerPillar, setSelectedOwnerPillar, user, highwayTerritory) => {  

    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefPillar.current.value;
    if (coordinatesPillar.length === 0 || comment.trim() === '' || selectedOwnerPillar == null) {
        showSnackbar('Опора! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(pillarMarker == true){
        showSnackbar('Опора! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    } else{
        try {
        await Promise.all(coordinatesPillar.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_PILLAR_HIGHWAY_API_URL}?flag=${flag}`, {
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                City: city,
                Canton: canton,
                Area: area,
                Status: 1,
                Rank: 0,
                OwnerPillarId: selectedOwnerPillar,
                AuthorId: user,      
            },
             {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        }));
        
        setCoordinatesPillar([]);
        setCommentPillar(""); 
        setSelectedOwnerPillar(null);
        handleClickSummit();      
        showSnackbar('Опора! Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

//запись PillarCanton ВРУЧНУЮ
export const WritePillarManuallyCanton = async (event, lat, lng,  selectedCanton, selectedRegoin, selectedArea, user, commentTextAreaRefPillar, selectedOwnerPillar, highwayTerritory,
    setCoordinatesManuallyPillae, showSnackbar) => {     

const token = localStorage.getItem('token');

event.preventDefault();
const comment = commentTextAreaRefPillar.current.value;
if ((lat === 0 && lng === 0)|| comment.trim() === '' || selectedOwnerPillar == null) {
    showSnackbar('Опора! Для записи в таблицу необходимо заполнить координаты, комментарий!', 'snackbarWarning');
    return;
}else if(!token){
    showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
} else{
    try {
   
        await axios.post(`${POST_PILLAR_MANUALLY_CANTON_API_URL}`, {
            Latitude: lat,
            Longitude: lng,
            Description: comment,
            Canton: selectedCanton,
            Regoin: selectedRegoin ?? 0, 
            Area: selectedArea ?? 0,
            Status: 1,
            Rank: 0,
            OwnerPillarId: selectedOwnerPillar,
            AuthorId: user,      
        },
         {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    
    setCoordinatesManuallyPillae('');
    highwayTerritory();      
    showSnackbar('Опора! Данные сохранены успешно', 'snackbarOk');
    } catch (error) {
        if (error.response) {
            console.error("Ошибка 400:", error.response.data);
            if (error.response.data.errors) {
              console.error("Ошибки валидации:", error.response.data.errors);
              showSnackbar(`Ошибка: ${JSON.stringify(error.response.data.errors)}`, 'snackbarError');
            } else {
              showSnackbar(`Ошибка ${error.response.status}: ${error.response.data.title}`, 'snackbarError');
            }
          } else {
            console.error("Ошибка сети:", error.message);
            showSnackbar("Ошибка сети: " + error.message, 'snackbarError');
          }
    } 
}
}

//запись PillarHighway ВРУЧНУЮ
export const WritePillarManuallyHighway = async (event, lat, lng, selectedCity, user, commentTextAreaRefPillar, selectedOwnerPillar, highwayTerritory,
    setCoordinatesManuallyPillae, showSnackbar) => {     

const token = localStorage.getItem('token');

event.preventDefault();
const comment = commentTextAreaRefPillar.current.value;
if ((lat === 0 && lng === 0)|| comment.trim() === '' || selectedOwnerPillar == null) {
    showSnackbar('Опора! Не все поля заполнены!', 'snackbarWarning');
    return;
}else if(!token){
    showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
} else{
    try {
   
        await axios.post(`${POST_PILLAR_MANUALLY_HIGHWAY_API_URL}`, {
            Latitude: lat,
            Longitude: lng,
            Description: comment,
            City: selectedCity,
            Status: 1,
            Rank: 0,
            OwnerPillarId: selectedOwnerPillar,
            AuthorId: user,      
        },
         {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    
    setCoordinatesManuallyPillae('');
    highwayTerritory();      
    showSnackbar('Опора! Данные сохранены успешно', 'snackbarOk');
    } catch (error) {
        if (error.response) {
            console.error("Ошибка 400:", error.response.data);
            if (error.response.data.errors) {
              console.error("Ошибки валидации:", error.response.data.errors);
              showSnackbar(`Ошибка: ${JSON.stringify(error.response.data.errors)}`, 'snackbarError');
            } else {
              showSnackbar(`Ошибка ${error.response.status}: ${error.response.data.title}`, 'snackbarError');
            }
          } else {
            console.error("Ошибка сети:", error.message);
            showSnackbar("Ошибка сети: " + error.message, 'snackbarError');
          }
    } 
}
}

//запись CouplingHighway
export const WriteCouplingHighway = async (event, coordinatesCoupling, selectedCoupling, commentTextAreaRefCoupling, selectedCity, couplingMarker, showSnackbar, 
    setCoordinatesCoupling, setCommentCoupling,handleClickSummit,setSelectedCoupling,selectedRankCouling, setSelectedRankCoupling, user,highwayTerritory) => {      
        
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefCoupling.current.value;
    if (coordinatesCoupling.length === 0 || comment.trim() === '' || selectedRankCouling == null) {
        showSnackbar('Муфта! Не все поля заполнены!', 'snackbarWarning');
        return;
    } else if(couplingMarker == true){
        showSnackbar('Муфта! Завершите действие!', 'snackbarWarning');
    } else if(!token){
        showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else{

        try {
        await Promise.all(coordinatesCoupling.map(async (coordinate) => {
            let city = 'null';
            let canton = 'null';
            let area = 0;
            let flag = '';
        
            if(highwayTerritory){
                flag = 'highway';
                city = selectedCity;
            }else{
                flag = 'canton';
                if (coordinate.flagTerritory === 'city') {
                    city = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'canton') {
                    canton = coordinate.polygonInfo;
                } else if (coordinate.flagTerritory === 'area') {
                    area = coordinate.polygonInfo;
                }
            }

            await axios.post(`${POST_COUPLING_HIGHWAY_API_URL}?flag=${flag}`, {
                CouplingId: selectedCoupling,
                Latitude: coordinate.lat,
                Longitude: coordinate.lng,
                Description: comment,
                City: city,
                Canton: canton,
                Area: area,
                Status: 1,
                RankComponentId: selectedRankCouling,
                AuthorId: user                
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        }));
            
        setCoordinatesCoupling([]);
        setCommentCoupling("");
        handleClickSummit();
        setSelectedCoupling([]);
        setSelectedRankCoupling(null);
        showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
            console.error("Ошибка при сохранении данных:", error);
        } 
    }
}


// запись таблицу KTVAmplifier
export const WriteKtvAmplifierNode = async (event, selectedAmplifierData, cantonRefresh,setSelectedAmplifierData,  hid, entrance, showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    //const comment = commentTextAreaRefAmplifier.current.value;

    if (selectedAmplifierData === null || selectedAmplifierData === "null" || selectedAmplifierData === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_KTV_AMPLIFIER_NODE_API_URL}`, 
                { ktvAmplifierId: selectedAmplifierData, hid, entrance }, // Все параметры в теле запроса
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedAmplifierData([]);
        cantonRefresh();
        
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу KTVAmplifier ( PASSIVE NODE)
export const WriteKtvAmplifierPassiveNode = async (event, selectedAmplifierData, cantonRefresh,setSelectedAmplifierData,  nodeId, authorId, showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();

    if (selectedAmplifierData === null || selectedAmplifierData === "null" || selectedAmplifierData === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_KTV_AMPLIFIER_PASSIVE_NODE_API_URL}`, 
                { ktvAmplifierId: selectedAmplifierData, hid: nodeId, authorId }, // Все параметры в теле запроса
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedAmplifierData([]);
        cantonRefresh();
        
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу OP
export const WriteOpNode = async (event, selectedOp, cantonRefresh,setSelectedOp,  hid, entrance, showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    //const comment = commentTextAreaRefAmplifier.current.value;

    if (selectedOp === null || selectedOp === "null" || selectedOp === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_OP_NODE_API_URL}`, 
                { OpticalReceiverId: selectedOp, hid, entrance }, // Все параметры в теле запроса
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedOp([]);
        cantonRefresh();
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу OP (PASSIVE NODE)
export const WriteOpPassiveNode = async (event, selectedOp, cantonRefresh,setSelectedOp,  nodeId, authorId, showSnackbar) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    //const comment = commentTextAreaRefAmplifier.current.value;

    if (selectedOp === null || selectedOp === "null" || selectedOp === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_OP_PASSIVE_NODE_API_URL}`, 
                { OpticalReceiverId: selectedOp, hid:nodeId, authorId }, // Все параметры в теле запроса
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedOp([]);
        cantonRefresh();
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу DIVIDER
export const WriteDividerNode = async (event, selectedDivider, cantonRefresh,setSelectedDivider,  hid, entrance, showSnackbar, commentTextAreaRefDivider, setCommentDivider,
                statusPon, statusKtv, setStatusPon, setStatusKtv
            ) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefDivider.current.value;

    if (selectedDivider === null || selectedDivider === "null" || comment.trim() === '' || selectedDivider === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
          // 🔹 преобразование boolean → 0 / 1
        const ponValue = statusPon ? 1 : 0;
        const ktvValue = statusKtv ? 1 : 0;

        try {
            await axios.post(
                `${POST_DIVIDER_NODE_API_URL}`, 
                { DividerId: selectedDivider, hid, entrance, description: comment, statusPon: ponValue, statusKtv: ktvValue }, 
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedDivider([]);
        setCommentDivider('');
        setStatusPon(false);
        setStatusKtv(false);
        cantonRefresh();
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу DIVIDER PASSIVE NODE
export const WriteDividerPassiveNode = async (event, selectedDivider, cantonRefresh,setSelectedDivider, nodeId, user, showSnackbar, commentTextAreaRefDivider, setCommentDivider,
     statusPon, statusKtv, setStatusPon, setStatusKtv
) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefDivider.current.value;

    if (selectedDivider === null || selectedDivider === "null" || comment.trim() === '' || selectedDivider === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
         // 🔹 преобразование boolean → 0 / 1
        const ponValue = statusPon ? 1 : 0;
        const ktvValue = statusKtv ? 1 : 0;

        try {
            await axios.post(
                `${POST_DIVIDER_PASSIVE_NODE_API_URL}`, 
                { DividerId: selectedDivider, hid: nodeId, authorId: user, description: comment, statusPon: ponValue, statusKtv: ktvValue }, 
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedDivider([]);
        setCommentDivider('');
        setStatusPon(false);
        setStatusKtv(false);
        cantonRefresh();
        showSnackbar('Делитель добавлен', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу CASSETTE
export const WriteCassetteNode = async (event, selectedCassette, cantonRefresh,setSelectedCassette,  hid, entrance, showSnackbar, commentTextAreaRefCassette, setCommentCassette) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefCassette.current.value;

    if (selectedCassette === null || selectedCassette === "null" || comment.trim() === '' || selectedCassette === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_CASSETTE_NODE_API_URL}`, 
                { DividerId: selectedCassette, hid, entrance, description: comment, }, 
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedCassette([]);
        setCommentCassette('');
        cantonRefresh();
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись таблицу CASSETTE PassiveNode
export const WriteCassettePassiveNode = async (event, selectedCassette, cantonRefresh,setSelectedCassette, nodeId, showSnackbar, commentTextAreaRefCassette, setCommentCassette) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefCassette.current.value;

    if (selectedCassette === null || selectedCassette === "null" || comment.trim() === '' || selectedCassette === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_CASSETTE_PASSIVE_NODE_API_URL}`, 
                { DividerId: selectedCassette, hid: nodeId, description: comment, }, 
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setSelectedCassette([]);
        setCommentCassette('');
        cantonRefresh();
        showSnackbar('Кассета добавлена', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}

// запись в таблицу резерва
export const WriteReserveNode = async (event, selectedReserveData, cantonRefresh,setSelectedReserveData,  hid, entrance, 
    showSnackbar, commentTextAreaRefReserve, setCommentReserve) => {
   
    const token = localStorage.getItem('token');

    event.preventDefault();
    const comment = commentTextAreaRefReserve.current.value;

    if (selectedReserveData === null || selectedReserveData === "null" || selectedReserveData === undefined) {
        showSnackbar('Не заполнены поля!', 'snackbarWarning');
        return;
    
    } else if(!token){
      //  showSnackbar('Ошибка! Токен не найден!', 'snackbarWarning');
    }else {
        try {
            await axios.post(
                `${POST_RESERVE_NODE_API_URL}`, 
                { reserveNodeId: selectedReserveData, hid, entrance, reserveNodeDescription: comment, }, // Все параметры в теле запроса
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
                        
        //setCommentAmplifier("");
        setCommentReserve("");
        setSelectedReserveData(null);
        cantonRefresh();
        
       // showSnackbar('Данные сохранены успешно', 'snackbarOk');
        } catch (error) {
        console.error("Ошибка при сохранении данных:", error);
        } 
    }
}



